import FetchHelper from './OldFetchHelper';
import LocalStorageHelper from './OldLocalStorageHelper';
import config from '../../config';
import OldErrorHandlerHelper from './OldErrorHandlerHelper';

class LanguageHelper {
  async fetchLanguages() {
    if(this.languages) return this.languages;
    this.languages = LocalStorageHelper.getLanguagesList();
    if(!this.languages) {
      const fetchConfig = {
        path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.languages}`,
      };
      const fetchResult = await FetchHelper.get(fetchConfig);
      if(fetchResult.success) {
        this.languages = fetchResult.data;
        LocalStorageHelper.setLanguagesList(this.languages);
      } else {
        OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
        return [];
      }
    }
    return this.languages;
  }

  async fetchCountries() {
    const fetchConfig = {
      path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.countries}`,
    };
    const fetchResult = await FetchHelper.get(fetchConfig);
    if(fetchResult.success) {
      // TODO : LocalStorageHelper.setLanguagesList(this.languages);
      return fetchResult.data;
    }
    // TODO error handling
    OldErrorHandlerHelper.handleError(fetchResult, { logToConsole: true });
    return false;
  }

  getQueryParam(name) {
    const results = new RegExp(`[?&]${name}=([^&#]*)`).exec(window.location.href);
    if(results == null) {
      return null;
    }
    return decodeURI(results[1]) || 0;
  }

  getLanguageParameter() {
    const lang = this.getQueryParam(`lang`);
    return lang !== null ? `lang=${lang}&` : ``;
  }
}

export default new LanguageHelper();
